import { makeStyles } from "@saleor/macaw-ui";

export const useStyles = makeStyles(
  {
    colActions: {
      width: 84,
    },
    colName: {
      width: "auto",
    },
    colProducts: {
      textAlign: "right",
      width: 140,
    },
    tableRow: {
      cursor: "pointer",
    },
  },
  { name: "DiscountCategories" },
);
